import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";
import type { ContactType, QueryType } from "@/common/types/common";

export async function contactList(
  account_id: string,
  owner_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/contact/${owner_id}/list${queryString}`,
  );
}

export async function contactCreate(
  account_id: string,
  owner_id: string,
  payload: ContactType,
) {
  return await clientAxios.post(
    `account/${account_id}/contact/${owner_id}/create`,
    payload,
  );
}

export async function contactGet(account_id: string, contact_id: string) {
  return await clientAxios.get(
    `account/${account_id}/contact/${contact_id}/show`,
  );
}

export async function contactUpdate(
  account_id: string,
  contact_id: string,
  payload: ContactType,
) {
  return await clientAxios.put(
    `account/${account_id}/contact/${contact_id}/update`,
    payload,
  );
}

export async function contactDelete(account_id: string, contact_id: string) {
  return await clientAxios.del(
    `account/${account_id}/contact/${contact_id}/delete`,
  );
}
